import { ActivityType } from 'modules/trainingLibrary/TrainingLibrary/types'

const routes = {
  root: `/${ActivityType.RapidElearning}`,
}

export default routes
